import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const trustItems = [
    { icon: 'ri-shield-check-line', key: 'hero_trust1' },
    { icon: 'ri-star-fill', key: 'hero_trust2' },
    { icon: 'ri-time-line', key: 'hero_trust3' },
    { icon: 'ri-customer-service-2-line', key: 'hero_trust4' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/b48d7c41cbfd8d7abefeec66c44f38eb.jpg"
          alt="Modern home with water purification"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Dark gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/50 to-slate-900/70"></div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-slate-900/40 to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center pt-24">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
          <div className="w-2 h-2 rounded-full bg-sky-400"></div>
          <span className="text-white/90 text-sm font-medium">{t('hero_badge')}</span>
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6 tracking-tight">
          {t('hero_title1')}<br />
          <span className="text-sky-400">{t('hero_title2')}</span><br />
          {t('hero_title3')}
        </h1>

        {/* Subheadline */}
        <p className="text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed font-medium">
          {t('hero_subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/water-purification"
            className="bg-sky-500 hover:bg-sky-400 text-white font-bold px-8 py-4 rounded-lg flex items-center gap-3 whitespace-nowrap transition-all cursor-pointer text-base min-w-[240px] justify-center"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-drop-line text-lg"></i>
            </div>
            {t('hero_cta_water')}
          </Link>
          <Link
            to="/windows-services"
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm border-2 border-white/60 text-white font-bold px-8 py-4 rounded-lg flex items-center gap-3 whitespace-nowrap transition-all cursor-pointer text-base min-w-[240px] justify-center"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-window-line text-lg"></i>
            </div>
            {t('hero_cta_windows')}
          </Link>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-14">
          {trustItems.map((item) => (
            <div key={item.key} className="flex items-center gap-2 text-white/80 text-sm">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-sky-400 text-base`}></i>
              </div>
              <span>{t(item.key)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
